import { cn } from '../../lib/utils'

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const sizeMap = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-10 w-10 border-[3px]',
}

export default function Spinner({ size = 'md', className }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label="로딩 중"
      className={cn(
        'inline-block rounded-full border-current border-t-transparent animate-spin',
        'text-brand-primary',
        sizeMap[size],
        className,
      )}
    />
  )
}
